const root = 'importList-importListProduct'
const tabs = `${root}-tabs`
const productHeaderPrice = `${root}-productHeaderPrice`
const productHeaderProfit = `${root}-productHeaderProfit`
const moreMenu = `${root}-3dotsMenu`

export const TestId = {
  root,
  selectProductCheckbox: `${root}-selectProductCheckbox`,
  thumbnailImage: `${root}-thumbnailImage`,
  thumbnailImageZoomed: `${root}-thumbnailImage-zoom`,
  productName: `${root}-productName`,
  productHeaderPrice,
  productHeaderPriceMin: `${productHeaderPrice}-min`,
  productHeaderPriceMax: `${productHeaderPrice}-max`,
  productHeaderProfit,
  productHeaderProfitMin: `${productHeaderProfit}-min`,
  productHeaderProfitMax: `${productHeaderProfit}-max`,
  productHeaderQuantity: `${root}-productHeaderQuantity`,
  moreMenu,
  moreMenuButton: `${moreMenu}-button`,
  moreMenuViewProductAction: `${moreMenu}-viewProduct`,
  moreMenuRevertAction: `${moreMenu}-revert`,
  moreMenuOrderSampleAction: `${moreMenu}-orderSample`,
  moreMenuRemoveAction: `${moreMenu}-remove`,
  moreMenuViewOnThirdPartyAction: `${moreMenu}-viewOn3rdParty`,
  customizeButton: `${root}-customizeButton`,
  addToStoreButton: `${root}-addToStoreButton`,
  tabs,
  tab: tabId => `${tabs}-${tabId}`,
  tabErrorIcon: tabId => `${tabs}-${tabId}-errorIcon`,
}
